<div class="container-fluid" *ngIf="!post">
    <div class="row mt-5 mb-5 col-sm-12 justify-content-center">
        <mat-spinner [diameter]="50"></mat-spinner>
    </div>
</div>
<div *ngIf="post" class="post-holder">
    <section class="container">
        <div class="text-center pt-5">
            <small>{{ post.createdDate }}
            </small>

            <h1 class="mt-3 font-weight-bold">{{ post.title }}</h1>
        </div>
    </section>
    <section class="container-fluid blog-hero mt-5 rounded" [style.background]="post.imagePath">
       
    </section>


    <!-- main blog section -->

    <div class="container blog-body">

        <div class="ql-editor" [innerHTML]="post.body"></div>

        <div id="my-inline-share-buttons" class="mt-5 mb-4"></div>

        <div class="row blog-user mt-5">
            <div class="col-12">
                <div class="media">
                    <a class="float-left" href="#">
                        <img *ngIf="post.authorImage" class="media-object dp rounded-circle mr-3" [src]="post.authorImage" style="width: 100px;height:100px;object-fit: cover;">
                        <div *ngIf="!post.authorImage" class="author-holder">
                            <div class="text">
                                {{ post.authorName.slice(0,1).toUpperCase() }}
                            </div>
                        </div>
                    </a>
                    <div class="media-body ml-3 mt-4">
                        <h5 class="media-heading" *ngIf="post.authorLink"><a [href]="post.authorLink">{{ post.authorName}}</a></h5>
                        <h5 class="media-heading" *ngIf="!post.authorLink">{{ post.author.firstName }} {{ post.authorName }}</h5>
                        <small class="d-block">Editor at <a href="https://neprose.com">Neprose.Com</a></small>
                    </div>
                </div>
            </div>
        </div>

        <div class="row  mt-5">
            <div class="col-lg-12  col-md-12">
                <div class="comment-wrapper">
                    <div class="card text-white bg-light">
                        <div class="card-header bg-danger">
                            <i class="fas fa-comments"></i> Comment Section 
                        </div>
                        <div class="fb-comments p-2" #commentSection data-href="https://neprose.com" data-width="100%" data-numposts="5"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section id="blogs" class="mt-5">
        <div class="blogs">
            <div class="container" *ngIf="similarList.length > 0">
                <h2 class="text-center mb-5">Similar Blogs</h2>
                <div class="row pt-4 justify-content-center">
                    <div class="col-md-6 col-sm-12 col-lg-4" *ngFor="let blog of similarList">
                        <div class="card">
                            <img [src]="blog.featuredImage">
                            <div class="p-2">
                                <div class="date">{{ blog.publishedDate }}</div>
                                <h4><a [routerLink]="['/blog/'+blog.slug]">{{ blog.title }}</a></h4>
                                <small class="strong pb-3">{{ blog.minRead }}</small>
                                <p class="excerpt text-justify pt-3">{{ blog.excerpt }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container" *ngIf="similarList.length == 0">
                <div class="row">
                    <div class="col-sm-12">
                        <h1 class="text-center">No Related Blogs Available</h1>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>